/* eslint-disable */
<template>
  <div>
    <div class="container-fluid w-100 no-padding">
      <div class="row bg-primary-dark">
        <div class="col-md-6 mb-2 mt-2">
          <input class="form-control block btn-more-radius" @keyup.enter="searchArizaKayitlari()" v-model="searchFilter" type="text" placeholder="Müşteri, Plaka, IMEI ile arama yapın...">
        </div>
        <div class="col-md-4 mb-2 mt-2">
          <select @change="listModeChange()" v-model="listingMode" class="form-control btn-more-radius float-left" id="exampleFormControlSelect1">
            <option value="-1">Tüm Kayıtları Göster</option>
            <option value="0" selected>Teslim Alınanları Göster</option>
            <option value="4"> Ön İnceleme Aşamasındakileri Göster</option>
            <option value="1">Teknik Servistekileri Göster</option>
            <option value="2">İşlemi Tamamlananları Göster</option>
            <option value="3">Kargoya Verilmiş Olanları Göster</option>
            <option value="5">Elden Teslim Edilenleri Göster</option>
            <option value="6">Stoka Taşınanları Göster</option>
          </select>
        </div>
        <div class="col-md-2 mb-2 mt-2">
          <router-link to="/ariza-kaydi-ekle" class="btn btn-more-radius btn-success float-right" v-if="canAddAriza">Yeni Arıza Kaydı Ekle</router-link>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <v-wait for="arizalar-loading">
            <template slot="waiting">
              <div class="vue-wait-class">
                <img src="static/loading.svg" />
                <p>Veriler yükleniyor...</p>
              </div>
            </template>
            <table class="table table-bordered">
              <caption class="pl-3">{{listStatusMessage}}</caption>
              <thead class="thead-light">
                <tr>
                  <th style="width: 8%;" scope="col">GELİŞ</th>
                  <th style="width: 12%;" scope="col">MÜŞTERİ</th>
                  <th style="width: 12%;" scope="col">ARAÇ PLAKASI</th>
                  <th style="width: 12%;" scope="col">SERİ NO.</th>
                  <th style="width: 12%;" scope="col">DURUM</th>
                  <th v-if="listingMode==1 || listingMode==2 || listingMode==4" style="width: auto;" scope="col">SON BİLGİ</th>
                  <th v-if="listingMode==3 || listingMode==5" style="width: 5%;" scope="col">GÖNDERİ TARİHİ</th>
                  <th v-if="listingMode==3 || listingMode == -1" style="width: 10%;" scope="col">KARGO TAKİP</th>
                  <th scope="col">KOMUTLAR</th>
                </tr>
              </thead>
              <tbody class="tbody-margin">
                <template v-for="(ariza, index) in arizalar">
                  <tr :key="'trow-first-' + ariza.ARIZA_ID">
                    <td class="align-middle">
                      <div class="text-truncate"><!--//ariza.ARIZA_ID-->
                        <p class="margin-negative">{{ariza.ARRIVAL_DATE}}</p>
                        <small class="text-muted">{{ariza.PERSONEL_NAME}}</small>
                      </div>
                    </td>
                    <td class="align-middle text-uppercase">
                      <div class="text-truncate">
                        <p class="my-0 font-weight-bold margin-negative">{{cropData(ariza.CUSTOMER_TITLE, 25)}}</p>
                        <small class="text-muted">{{ariza.RETAILER_NAME}}</small>
                      </div>
                    </td>
                    <td class="align-middle" :alt="ariza.VEHICLE_NAME">
                      <div class="text-truncate justify-content-center">
                        <p class="my-0 text-uppercase margin-negative">{{cropData(ariza.VEHICLE_NAME, 20)}}</p>
                        <small v-if="ariza.CUSTOMER_ID == 557 || ariza.CUSTOMER_ID == 292 || ariza.CUSTOMER_ID == 2004" class="text-muted">{{ariza.GROUP_NAME}}</small>
                      </div>
                    </td>
                    <td class="align-middle">
                      <!--<div>
                        <p class="my-0 font-weight-bold" v-bind:class="{'text-danger': ariza.DEVICE_WARRANTY_PERIOD == 1}">{{ariza.DEVICE_ID}}</p>
                        <small class="text-muted">{{ariza.DEVICE_LABEL}}</small>
                      </div>-->
                      <div class="ml-2" v-if="ariza.OUTGOING_DEVICE_ID == null || (ariza.OUTGOING_DEVICE_ID == ariza.DEVICE_ID)">
                        <div v-if="ariza.DEVICE_WARRANTY_PERIOD == 1" class="icon-global bg-danger align-middle text-center">
                          <i class="fas fa-heart-broken"></i></div>
                        <p class="my-0 font-weight-bold margin-negative" v-bind:class="{'text-danger': ariza.DEVICE_WARRANTY_PERIOD == 1}">{{ariza.DEVICE_ID}}</p>
                        <small class="text-muted">{{ariza.DEVICE_LABEL}}</small>
                      </div>
                      <div class="ml-2" v-else>
                        <div class="icon-global bg-primary align-middle text-center"><i class="fas fa-sync-alt"></i></div>
                        <p class="my-0 font-weight-bold text-danger margin-negative">{{ariza.DEVICE_ID}}</p>
                        <small class="text-muted">{{ariza.DEVICE_LABEL}}</small>
                        <div class="mb-1"></div>
                        <p class="my-0 font-weight-bold text-success margin-negative">{{ariza.OUTGOING_DEVICE_ID}}</p>
                        <small class="text-muted">{{ariza.OUTGOING_DEVICE_LABEL || 'TANIMSIZ'}}</small>
                      </div>
                    </td>
                    <td class="align-middle text-center">
                      <div class="dropdown">
                        <button :class="parseArizaDurumAsClass(ariza.STATUS)" class="btn btn-sm btn-block btn-more-radius dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                          {{parseArizaDurum(ariza.STATUS)}}
                        </button>
                        <div v-if="canUpdateAriza" class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                          <a class="dropdown-item border-bottom" @click="assignStatusToAriza(ariza.ARIZA_ID, ariza.STATUS, 0, index)">1 - TESLİM ALINDI</a>
                          <a class="dropdown-item border-bottom" @click="assignStatusToAriza(ariza.ARIZA_ID, ariza.STATUS, 4, index)">2 - ÖN İNCELEMEDE</a>
                          <a class="dropdown-item border-bottom" @click="assignStatusToAriza(ariza.ARIZA_ID, ariza.STATUS, 1, index)">3 - TEKNİK SERVİSTE</a>
                          <a class="dropdown-item border-bottom" @click="assignStatusToAriza(ariza.ARIZA_ID, ariza.STATUS, 2, index)">4 - İŞLEM TAMAMLANDI</a>
                          <a class="dropdown-item disabled" tabindex="-1" aria-disabled="true">5 - KARGOLANDI</a>
                          <a class="dropdown-item disabled" tabindex="-1" aria-disabled="true">6 - ELDEN TESLİM EDİLDİ</a>
                          <!-- @click="assignStatusToAriza(ariza.ARIZA_ID, ariza.STATUS, 3, index)" -->
                        </div>
                      </div>
                    </td>
                    <td v-if="listingMode==1 || listingMode==2 || listingMode==4" class="align-middle justify-content-between lh-condensed">
                      <div class="text-truncate" :data-toggle2="ariza.LAST_MESSAGE ? 'tooltip' : ''" :title="parseLastMessage(ariza.LAST_MESSAGE)[0]" data-placement="bottom">
                        <p class="margin-negative">{{cropData(parseLastMessage(ariza.LAST_MESSAGE)[0], 31)}}</p>
                        <small class="text-muted">{{parseLastMessage(ariza.LAST_MESSAGE)[1]}}, {{parseLastMessage(ariza.LAST_MESSAGE)[2]}}</small>
                      </div>
                    </td>
                    <td v-if="listingMode==3 || listingMode == 5" class="align-middle">
                      <div v-if="ariza.POST_WAYBILL_CODE" class="text-truncate">
                        <p class="margin-negative">{{ariza.POST_WAYBILL_CODE}}</p>
                        <small class="text-muted text-uppercase">{{ariza.POST_DATE}}</small>
                      </div>
                      <div v-else class="text-truncate">
                        <p class="margin-negative">{{ariza.POST_DATE}}</p>
                        <small class="text-muted text-uppercase">İ / F YOK</small>
                      </div>
                    </td>
                    <td v-if="(ariza.STATUS == 3 && listingMode == 3) || listingMode == -1" class="align-middle text-center">
                      <!--<a v-if="ariza.POST_TRACKING_CODE" target="_blank" role="button" class="btn btn-link" :href="parsePostTrackingLink(ariza.POST_TRACKING_CODE)">
                        {{ariza.POST_TRACKING_CODE}}
                      </a>-->
                      <div class="justify-content-between">
                        <a v-if="ariza.POST_TRACKING_CODE" target="_blank" role="button" class="btn btn-sm" :href="parsePostTrackingLink(ariza.POST_TRACKING_CODE, ariza.POST_COMPANY)">
                          <img :src="'static/kargo/' + ariza.POST_COMPANY + '.png'" class="mr-2" width="24" height="24" />
                          <span class="mt-2">{{ariza.POST_TRACKING_CODE}}</span>
                        </a>
                        <span v-else>{{ariza.POST_TRACKING_CODE}}</span>
                      </div>
                    </td>
                    <td class="align-middle text-center">
                      <div class="btn-group">
                        <button class="btn btn-outline-primary btn-more-radius dropdown-toggle"
                          type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                          İşlemler
                        </button>
                        <div class="dropdown-menu dropdown-menu-right">
                          <a role="button" class="dropdown-item" data-toggle="modal"
                            data-target="#conversationModal" :disabled="!canReadMessage" @click="openArizaMesajlari(ariza.ARIZA_ID, index)">
                            <i class="fas fa-comments"></i>&nbsp;&nbsp;İşlem Geçmişini Göster</a>
                          <a v-if="ariza.STATUS == 3" role="button" class="dropdown-item" data-toggle="modal" data-target="#trackNumberModal"
                             @click="selectAriza(ariza.ARIZA_ID, index)" :disabled="!canAssignTrackingNumber">
                            <i class="fas fa-archive"></i>&nbsp;&nbsp;Takip Numarası Ekle</a>
                          <a v-if="ariza.STATUS == 2" class="dropdown-item" aria-expanded="false"
                            data-toggle="modal" data-target="#exportDeviceModal" @click="selectAriza(ariza.ARIZA_ID, index)" :disabled="!canUpdateAriza">
                            <i class="fas fa-envelope"></i>&nbsp;&nbsp;Ürün Çıkışı Yap</a>
                          <a class="dropdown-item" aria-expanded="false" @click="selectAriza(ariza.ARIZA_ID, index)" :disabled="!canMoveAriza"
                            v-if="isRecordMovable(ariza.STATUS, ariza.OUTGOING_DEVICE_ID)"
                            data-toggle="modal" data-target="#moveDeviceToStokModal">
                            <i class="fas fa-file-export"></i>&nbsp;&nbsp;Cihazı Stoka Taşı</a>
                          <h6 class="dropdown-header mt-2">Diğer İşlemler</h6>
                          <a class="dropdown-item text-danger" @click="selectAriza(ariza.ARIZA_ID, index)"
                            data-toggle="modal" data-target="#deleteArizaModal" :disabled="!canDeleteAriza"
                            aria-expanded="false"><i class="fas fa-trash-alt text-danger"></i>&nbsp;&nbsp;&nbsp;Arıza Kaydını Sil</a>
                        </div>
                      </div>
                      <!-- -->
                      <button class="btn btn-outline-primary btn-more-radius text-primary"
                        data-toggle="collapse" :href="'#collapsed-row-' + index" role="button" 
                        aria-expanded="false" :aria-controls="'collapsed-row-' + index">
                        <i class="fas fa-angle-double-down text-primary"></i>
                      </button>
                    </td>
                    <!--<td class="align-middle">
                      <div class="dropdown align-middle">
                        <button class="btn btn-sm btn-primary btn-block dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                          İŞLEMLER
                        </button>
                        <div v-if="canUpdateAriza" class="dropdown-menu dropdown-menu-right" aria-labelledby="dropdownMenuButton">
                          <a class="dropdown-item" href="#"><i class="fas fa-share-square"></i>&nbsp;&nbsp;Ürün Çıkışını Yap</a>
                          <a class="dropdown-item" role="button" @click="selectAriza(ariza.ARIZA_ID, index)" data-toggle="modal" data-target="#trackNumberModal">
                            <i class="fas fa-box-open"></i>&nbsp;&nbsp;Takip No Ekle</a>
                          <div class="dropdown-divider"></div>
                          <a class="dropdown-item" href="#"><i class="fas fa-times"></i>&nbsp;&nbsp;Arıza Kaydını Sil</a>
                        </div>
                      </div>
                    </td>-->
                  </tr>
                  <tr :key="'trow-second-' + ariza.ARIZA_ID" class="collapse collapsed-row" :id="'collapsed-row-' + index">
                    <th class="align-middle">BİLGİ NOTU</th>
                    <td class="align-middle">{{ariza.ARIZA_NOTE}}</td>
                    <th class="align-middle">GÖNDERİCİ ADI</th>
                    <td class="align-middle">{{ariza.INCOMING_SENDER_NAME}}</td>
                    <th class="align-middle">GÖNDERİ ADRESİ</th>
                    <td class="align-middle" colspan="3">{{ariza.INCOMING_ADDRESS}}</td>
                  </tr>
                  <tr :key="'trow-third-' + ariza.ARIZA_ID" class="collapse collapsed-row" :id="'collapsed-row-' + index">
                    <th colspan="2" class="align-middle">GELEN MALZEMELER</th>
                    <td colspan="5" class="align-middle">
                      <span class="mr-2 btn btn-more-radius" v-bind:class="{'btn-success': innerPiece.Status == 0, 'btn-danger': innerPiece.Status == 1}"
                        v-for="(innerPiece, indexPiece) in parseGelenMalzemeler(ariza.GELEN_MALZEMELER)" :key="'innerPiece-' + indexPiece">
                        {{innerPiece.PieceName}}
                        <!--<span class="badge" :class="innerPiece.Status == 0 ? 'badge-success' : 'badge-danger'">
                          {{innerPiece.Status == 0 ? 'Ekipman Sağlıklı' : 'Ekipman Arızalı'}}
                        </span>-->
                      </span>
                    </td>
                  </tr>
                </template>
                <tr>
                  <td colspan="8" class="text-center py-4" style="width: 100%">
                    <a role="button" class="btn btn-primary text-white"
                      :disabled="loadMoreClicked" @click="getArizaKayitlari()">
                      {{ loadMoreClicked ? "Yükleniyor..." : "Daha fazla kayıt yükle" }}
                    </a>
                  </td>
                </tr>
              </tbody>
            </table>
          </v-wait>
        </div>
      </div>
    </div>
    <div v-if="canReadMessage" class="modal fade bd-example-modal-lg" id="conversationModal" tabindex="-1" role="dialog" aria-labelledby="conversationModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content modal-lg">
          <div class="modal-header">
            <h5 class="modal-title" id="trackNumberModalLabel">İşlem Geçmişi</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div id="conversation-body-messages" class="modal-body modal-body-fixed">
            <v-wait for="mesajlar-loading">
              <template slot="waiting">
                <div class="vue-wait-class">
                  <img src="static/loading.svg" />
                  <p>Mesajlar yükleniyor...</p>
                </div>
              </template>
              <div class="container-fluid">
                <div class="row mb-4" :id="'message-row' + index" v-for="(message, index) in activeMessages" :key="message.MESSAGE_ID">
                  <div class="col-md-12">
                    <div class="bubble clearfix" v-bind:class="{'own text-right' : message.PERSONEL_ID == getPersonelId}">
                      <span class="my-0" v-bind:class="{'float-right' : message.PERSONEL_ID == getPersonelId}">{{message.MESSAGE_TEXT}}</span>
                      <small class="text-muted mt-1"
                        v-bind:class="{'float-right' : message.PERSONEL_ID == getPersonelId, 'float-left': message.PERSONEL_ID != getPersonelId}" >
                        {{message.MESSAGE_DATE}} - {{message.PERSONEL_NAME}}</small>
                    </div>
                  </div>
                </div>
              </div>
            </v-wait>
          </div>
          <div class="modal-footer">
            <div class="input-group">
              <textarea class="form-control" :disabled="!canWriteMessage" placeholder="Notunuzu buraya yazın..." v-model="arizaMessageText"
                aria-label="Notunuzu buraya yazın..." aria-describedby="button-addon2"></textarea>
              <div class="input-group-append">
                <button class="btn btn-primary" :disabled="!canWriteMessage" @click="insertArizaMesaji()" type="button" id="button-addon2">Notu Ekle</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="canAssignTrackingNumber" class="modal fade" id="trackNumberModal" tabindex="-1" role="dialog" aria-labelledby="trackNumberModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="trackNumberModalLabel">Takip Numarasını Girin</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="form-group">
              <!--<input type="text" class="form-control" v-model="trackingNumber" id="tracking-number-code">-->
              <label for="multiple-waybill-code">Kargo Takip Numarası</label>
              <div class="input-group">
                <input type="text" id="multiple-waybill-code" :disabled="handDelivery"
                  placeholder="Kargo takip numarası..."
                  v-model="trackingNumber" class="form-control form-control-lg" />
                <div class="input-group-append">
                  <button class="btn btn-outline-primary dropdown-toggle" type="button" 
                    data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                      <img width="24" height="24" class="mr-2" :src="'static/kargo/' + postCompany + '.png'" />
                      <span>{{postCompany == 0 ? 'MNG Kargo' : 'Aras Kargo'}}</span>
                  </button>
                  <div class="dropdown-menu">
                    <div class="dropdown-item justify-content-between" @click="selectPostComp(0)">
                      <img width="24" height="24" class="mr-2" src="static/kargo/0.png" />
                      <span>MNG Kargo</span>
                    </div>
                    <div class="dropdown-item justify-content-between" @click="selectPostComp(1)">
                      <img width="24" height="24" class="mr-2" src="static/kargo/1.png" />
                      <span>Aras Kargo</span>
                    </div>
                  </div>
                </div>
              </div>
              <small class="form-text text-muted mt-2">Girdiğiniz bilgi, ilgili müşteriye sms ve ya mail yoluyla bildirilecektir.</small>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-more-radius btn-secondary" data-dismiss="modal">Kapat</button>
            <button type="button" @click="assignTrackingNumberToAriza()" 
              class="btn btn-more-radius btn-primary">Takip Numarasını Kaydet</button>
          </div>
        </div>
      </div>
    </div>
    <div v-if="canUpdateAriza" class="modal fade" id="exportDeviceModal" tabindex="-1" role="dialog" aria-labelledby="exportDeviceModalLabel" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="trackNumberModalLabel">Ürün Çıkış Formunu Doldurun</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <v-wait for="export-loading">
              <template slot="waiting">
                <div class="vue-wait-class">
                  <img src="static/loading.svg" />
                  <p>Ürün çıkışı yapılıyor...</p>
                </div>
              </template>
              <div class="container-fluid">
                <div class="row">
                  <div class="col-md-12 mb-3">
                    <label for="post-date">Ürün Çıkış Tarihi</label>
                    <datepicker :bootstrap-styling="true" v-model="outgoingPostDate"
                      :format="dateFormatter"></datepicker>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12 mb-3">
                    <label for="outgoing-device-id">Gönderilen Cihaz Seri Numarası</label>
                    <input type="text" class="form-control" v-model="outGoingDeviceId" id="outgoing-device-id">
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12 mb-3">
                    <div class="custom-control custom-checkbox mr-sm-2">
                      <input type="checkbox" id="outgoing-hand-delivery" class="custom-control-input" v-model="handDelivery">
                      <label class="custom-control-label light-text" for="outgoing-hand-delivery">Bu ürün elden teslim edilmiştir.</label>
                      <small id="outgoing-hand-delivery" class="form-text text-muted">Bu seçeneği işaretlediğinizde bu arıza kaydı için kargo takip numarası girişi yapamazsınız. Aynı zamanda bu kayıt kargo takip numarası bekleyen kayıtlar listesinden de çıkarılmış olur.</small>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12 mb-3">
                    <label for="post-waybill-code">İrsaliye / Fatura Numarası</label>
                    <input type="text" class="form-control" :disabled="handDelivery" v-model="postWaybillCode" id="post-waybill-code">
                  </div>
                </div>
              </div>
            </v-wait>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Kapat</button>
            <button type="button" @click="arizaUrunCikisiYap()" class="btn btn-primary">Ürün Çıkışını Yap</button>
          </div>
        </div>
      </div>
    </div>
    <div v-if="canDeleteAriza" class="modal fade bd-example-modal-lg" id="deleteArizaModal" tabindex="-1"
      role="dialog" aria-labelledby="exportUmeModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="trackNumberModalLabel">Aşağıda bilgileri yer alan arıza kaydını silmek istediğinizden emin misiniz ?</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <v-wait for="ariza-deleting">
              <template slot="waiting">
                <div class="vue-wait-class">
                  <img src="static/loading.svg" />
                  <p>Arıza Kaydı Siliniyor...</p>
                </div>
              </template>
              <div class="container-fluid">
                <div class="row">
                  <div class="col-md-4 mb-3">
                    <label for="malzeme-kod">Müşteri Adı</label>
                    <input type="text" readonly class="form-control" id="malzeme-kod"
                      :value="selectedAriza.CUSTOMER_TITLE">
                  </div>
                  <div class="col-md-4 mb-3">
                    <label for="malzeme-name">Araç Plakası</label>
                    <input type="text" readonly class="form-control" id="malzeme-name"
                      :value="selectedAriza.VEHICLE_NAME">
                  </div>
                  <div class="col-md-4 mb-3">
                    <label for="malzeme-devid">Araç Plakası</label>
                    <input type="text" readonly class="form-control" id="malzeme-devid"
                      :value="selectedAriza.DEVICE_ID">
                  </div>
                </div>
                <hr />
                <div class="row">
                  <div class="col-md-6 mb-3">
                    <label for="add-qty">Ürün Geliş Tarihi</label>
                    <input type="text" class="form-control" readonly :value="selectedAriza.ARRIVAL_DATE" id="add-qty">
                  </div>
                  <div class="col-md-6 mb-3">
                    <label for="malzeme-fabrika">Kaydı Ekleyen Personel</label>
                    <input type="text" readonly class="form-control" :value="selectedAriza.PERSONEL_NAME" id="malzeme-fabrika">
                  </div>
                </div>
                <hr />
                <div class="row">
                  <div class="col-md-12 mb-3">
                    <label for="malzeme-ume">Arıza Kayıt Notu</label>
                    <textarea readonly class="form-control" :value="selectedAriza.ARIZA_NOTE" id="malzeme-ume"></textarea>
                  </div>
                </div>
              </div>
            </v-wait>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Kapat</button>
            <button type="button" @click="deleteAriza()" class="btn btn-danger">Arıza Kaydını Sil</button>
          </div>
        </div>
      </div>
    </div>
    <div v-if="canMoveAriza" class="modal fade" id="moveDeviceToStokModal" tabindex="-1" role="dialog"
      aria-labelledby="moveDeviceToStokModalLabel" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="trackNumberModalLabel">Cihazı Stoka Taşıyın</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <v-wait for="move-loading">
              <template slot="waiting">
                <div class="vue-wait-class">
                  <img src="static/loading.svg" />
                  <p>Cihaz taşınıyor...</p>
                </div>
              </template>
              <div class="container-fluid">
                <div class="row">
                  <div class="col-md-12 mb-4">
                    <label for="move-device-select">Aktarmak istediğiniz cihaz</label>
                    <select class="custom-select" id="move-device-select"
                      v-model="moveDeviceModel.DeviceId">
                      <option selected :value="selectedAriza.DEVICE_ID">{{selectedAriza.DEVICE_ID + ' (GELEN)'}}</option>
                    </select>
                    <small id="move-device-select" class="form-text text-muted">
                      Bu işlem ile birlikte işlem yaptığınız arıza kaydı arşivlenecek ve seçtiğiniz cihaz Lenoi Stokuna aktarılacaktır. 
                    </small>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12 mb-4">
                    <label for="move-device-status">Aktarmak istediğiniz durum</label>
                    <select class="custom-select" id="move-device-status" v-model="moveDeviceModel.Status">
                      <option selected value="-1">Stok türü seçiniz...</option>
                      <option value="0">Lenoi Stok</option>
                      <option value="1">Ü.M.E. Stok</option>
                      <option value="2">Fabrika Stok / Üretim Stoku</option>
                      <option value="3">Çıkışı Yapılmışlar</option>
                      <option value="4">Arızalı / Arıza Kayıt Listesinde</option>
                      <option value="5">Ölü Ürün / Stok Dışı</option>
                    </select>
                    <small id="move-device-status" class="form-text text-muted">
                      Aktarımını yaptığınız cihaz, yaptığınız seçime ait stok türüyle görüntülenecektir. 
                    </small>
                  </div>
                </div>
              </div>
            </v-wait>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Kapat</button>
            <button type="button" @click="moveDeviceToStok()" class="btn btn-primary">Cihazı Stoka Aktar</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */

import moment from 'moment'
import axios from 'axios'
import Datepicker from 'vuejs-datepicker'
export default {
  name: 'CihazlarPage',
  components: {
    'datepicker': Datepicker
  },
  data () {
    return {
      contextId: '',
      activeMessages: [],
      viewConversation: false,
      arizaMessageText: null,
      arizalar: [],
      selectedAriza: {},
      selectedArizaIndex: -1,
      selectedArizaId: -1,
      trackingNumber: null,
      listingMode: "0",
      searchFilter: null,
      outGoingDeviceId: null,
      outgoingNote: '',
      outgoingPostDate: '',
      postWaybillCode: '',
      postCompany: 0,
      handDelivery: false,
      pieces: [
        {"PieceName": "GSM Anteni", "PieceId": 1, "Status": 0, "Group": 2},
        {"PieceName": "GPS Anteni", "PieceId": 2, "Status": 0, "Group": 2},
        {"PieceName": "Power Kablosu", "PieceId": 3, "Status": 0, "Group": 2},
        {"PieceName": "SIM Kart", "PieceId": 4, "Status": 0, "Group": 2},
        {"PieceName": "Röle", "PieceId": 5, "Status": 0, "Group": 2},
        {"PieceName": "Röle Soketi", "PieceId": 6, "Status": 0, "Group": 2},
        {"PieceName": "Bloke Kablo", "PieceId": 7, "Status": 0, "Group": 2},
        {"PieceName": "İkili Max Ara Kablo", "PieceId": 8, "Status": 0, "Group": 2},
        {"PieceName": "LNX-66 IP Kamera", "PieceId": 9, "Status": 0, "Group": 1},
        {"PieceName": "LNC-104 IP Kamera", "PieceId": 10, "Status": 0, "Group": 1},
        {"PieceName": "DVR Kamera Power Kablo", "PieceId": 11, "Status": 0, "Group": 1},
        {"PieceName": "NVR Çoklu Power Kablo", "PieceId": 13, "Status": 0, "Group": 1},
        {"PieceName": "Ahtapot Kablo", "PieceId": 14, "Status": 0, "Group": 1},
        {"PieceName": "Acil Durum Butonu", "PieceId": 15, "Status": 0, "Group": 3},
        {"PieceName": "Monitör", "PieceId": 16, "Status": 0, "Group": 3},
        {"PieceName": "Kimlik Tanıma Birimi", "PieceId": 17, "Status": 0, "Group": 3},
      ],
      toastOptions: {
        theme: "bubble",
        position: "top-center",
        duration : 4000
      },
      moveDeviceModel: {
        DeviceId: '',
        OutGoingDeviceId: '',
        Status: -1,
        ArizaId: -1
      },
      page: 0,
      loadMoreClicked: false,
    }
  },
  computed: {
    getPersonelId : function() { return this.$store.getters.getPersonelId },
    getSessionId : function() { return this.$store.getters.getSessionId },
    canAddAriza : function() { return this.$store.getters.userCanAddAriza },
    canUpdateAriza : function() { return this.$store.getters.userCanUpdateAriza },
    canDeleteAriza : function() { return this.$store.getters.userCanDeleteAriza },
    canMoveAriza : function() { return true; },
    //canMoveAriza : function() { return this.$store.getters.userCanMoveAriza },
    canAssignTrackingNumber : function() { return this.$store.getters.userCanAssignTrackingNumber },
    canWriteMessage : function() { return this.$store.getters.userCanWriteMessage },
    canReadMessage : function() { return this.$store.getters.userCanReadMessage },
    listStatusMessage : function() { return this.arizalar.length + " adet kayıt görüntüleniyor." }
  },
  methods: {
    openArizaMesajlari(arizaId, arizaIndex) {
      console.log(this.getPersonelId == 3);
      if(this.selectedArizaId == arizaId && this.viewConversation == true) {
        this.viewConversation = false
        return
      }

      this.selectAriza(arizaId, arizaIndex)
      this.viewConversation = true
      this.getArizaMesajlari()
    },
    getArizaMesajlari() {
      this.$wait.start('mesajlar-loading');
      let sessionid = localStorage.getItem('utks-sessionid')
      let getJson = {}
      getJson.SessionId = sessionid
      getJson.ArizaId = this.selectedArizaId

      axios
      .post('/api/arizakayit/get-mesajlar', getJson)
      .then(response => {
        this.activeMessages = response.data
        this.$wait.end('mesajlar-loading')
      })
      .catch(error => {
        console.log(error)
        this.$wait.end('mesajlar-loading')
      })
    },
    insertArizaMesaji() {
      if(!this.arizaMessageText)
        return

      this.$wait.start('mesaj-insert');
      let sessionid = localStorage.getItem('utks-sessionid')
      let getJson = {}
      getJson.SessionId = sessionid
      getJson.ArizaId = this.selectedArizaId
      getJson.MessageText = this.arizaMessageText

      axios
      .post('/api/arizakayit/mesaj-ekle', getJson)
      .then(response => {
        this.$wait.end('mesaj-insert')
        this.arizaMessageText = null
        this.getArizaMesajlari()
      })
      .catch(error => {
        console.log(error)
        this.$wait.end('mesaj-insert')
      })
    },
    deleteAriza() {
      this.$wait.start('ariza-deleting')
      let sessionid = localStorage.getItem('utks-sessionid')
      let deleteJson = {}
      deleteJson.SessionId = sessionid;
      deleteJson.MalzemeId = this.selectedArizaId

      console.log(deleteJson)
      axios.post('/api/arizakayit/sil', deleteJson)
      .then(response => {
        this.$toasted.success('Arıza kaydı silindi.', this.toastOptions)      
        this.getArizaKayitlari()
      })
      .catch(error => {
        this.$toasted.success('Kayıt silinemedi. Durum mesajı: ' + error.data.ErrorMessage, this.toastOptions)      
      })

      this.$wait.end('ariza-deleting')
      $('#deleteArizaModal').modal('hide')

      this.selectedAriza = {}
      this.selectedArizaIndex = -1
      this.selectedArizaId = -1
    },
    moveDeviceToStok() {
      if(this.moveDeviceModel.Status == -1) {
        this.$toasted.error('Stok türünü seçmediniz !', this.toastOptions)
        return
      }

      this.moveDeviceModel.Status = parseInt(this.moveDeviceModel.Status)
      this.moveDeviceModel.SessionId = this.getSessionId
      axios
      .post('/api/arizakayit/stoka-tasi', this.moveDeviceModel)
      .then(response => {
        this.$toasted.success('Cihaz stoka taşındı.', this.toastOptions)
        this.arizaMessageText = null
        this.getArizaKayitlari()
      })
      .catch(error => {
        console.log(error)
      })

      this.$wait.end('move-loading')
    },
    searchArizaKayitlari() {
      this.page = 0;
      this.getArizaKayitlari();
    },
    getArizaKayitlari() {
      if(this.$route.params.id !== undefined)
        this.contextId = this.$route.params.id

      if(this.page == 0) 
        this.$wait.start('arizalar-loading')
      else
        this.loadMoreClicked = true;

      let sessionid = localStorage.getItem('utks-sessionid')
      let getJson = {}
      getJson.SessionId = sessionid
      getJson.ListingMode = this.listingMode
      getJson.Filter = this.searchFilter
      getJson.ContextId = this.contextId
      getJson.Page = this.page

      axios
      .post('/api/arizakayit/tum-kayitlar', getJson)
      .then(response => {

        if(this.page == 0)
          this.arizalar = response.data
        else
          this.arizalar.push(...response.data);

        this.page++;
        this.$wait.end('arizalar-loading')
        this.loadMoreClicked = false;
      })
      .catch(error => {
        console.log(error)
        this.$wait.end('arizalar-loading')
        this.loadMoreClicked = false;
      })
    },
    parseArizaDurum(arizaDurum) {
      if(arizaDurum == 0)
        return "TESLİM ALINDI"
      else if(arizaDurum == 1)
        return "TEKNİK SERVİSTE"
      else if(arizaDurum == 2)
        return "İŞLEM TAMAMLANDI"
      else if(arizaDurum == 3)
        return "KARGOLANDI"
      else if(arizaDurum == 4)
        return "ÖN İNCELEMEDE"
      else if(arizaDurum == 5)
        return "ELDEN TESLİM EDİLDİ"
      else if(arizaDurum == 6)
        return "CİHAZ STOKA TAŞINDI"
    },
    parseArizaDurumAsClass(arizaDurum) {
      if(arizaDurum == 0)
        return "btn-primary"
      else if(arizaDurum == 1)
        return "btn-warning"
      else if(arizaDurum == 2)
        return "btn-success"
      else if(arizaDurum == 3)
        return "btn-info"
      else if(arizaDurum == 4)
        return "btn-danger"
      else if(arizaDurum == 5)
        return "btn-secondary"
      else if(arizaDurum == 6)
        return "btn-outline btn-outline-danger"
    },
    assignStatusToAriza(arizaId, oldStatus, newStatus, arizaIndex) {
      if(oldStatus == newStatus)
        return;

      let sessionid = localStorage.getItem('utks-sessionid')
      let updateJson = {}
      updateJson.SessionId = sessionid
      updateJson.ArizaId = arizaId
      updateJson.NewStatus = newStatus
      axios.post('/api/arizakayit/durum-guncelle', updateJson)
      .then(response => {
        if(response.data.HasError == true)
          alert('Arıza kaydı durumu güncellenemedi')
        else
          this.arizalar[arizaIndex].STATUS = newStatus
      })
      .catch(error => console.log(error))
    },
    assignTrackingNumberToAriza() {
      alert(this.trackingNumber)

      if(this.handDelivery == false && (this.trackingNumber != null && this.trackingNumber.length > 0)) {
        if(this.regexCheck(this.trackingNumber) == false && this.postCompany == 0) {
          this.$toasted.error('MNG Kargo takip numarası doğru formatta girilmedi.', this.toastOptions)
          return
        }
        else if(this.regexCheckAras(this.trackingNumber) == false && this.postCompany == 1) {
          this.$toasted.error('Aras Kargo takip numarası doğru formatta girilmedi.', this.toastOptions)
          return
        }
        else {
          let eq = this.arizalar.filter(m => m.POST_TRACKING_CODE == this.trackingNumber
            && (m.CUSTOMER_ID != this.selectedAriza.CUSTOMER_ID || m.RETAILER_ID != this.selectedAriza.RETAILER_ID))

          if(eq != null && eq.length > 0) {
              this.$toasted.error('Kargo takip numarası farklı bir müşteriye yapılan gönderiye ait.', this.toastOptions)
              return;
          }
        }
      }

      let sessionid = localStorage.getItem('utks-sessionid')
      let assignJson = {}
      assignJson.SessionId = sessionid
      assignJson.ArizaId = this.selectedArizaId
      assignJson.TrackingNumber = this.trackingNumber ? this.trackingNumber : ''
      assignJson.PostCompany = this.postCompany
      
      axios.post('/api/arizakayit/takipno-ekle', assignJson)
      .then(response => {
        if(response.data.HasError == true)
          this.$toasted.error('Takip numarası kaydedilemedi. Durum mesajı : ' + response.data.ErrorMessage, this.toastOptions)
        else {
          this.$toasted.success('Takip numarası kaydedildi', this.toastOptions)
          this.arizalar[this.selectedArizaIndex].STATUS = 3
          this.arizalar[this.selectedArizaIndex].POST_TRACKING_CODE = this.trackingNumber
          this.arizalar[this.selectedArizaIndex].POST_COMPANY = this.postCompany
        }
        
        $("#trackNumberModal").modal('hide')
      })
      .catch(error => console.log(error))

      this.postCompany = 0
      this.trackingNumber = ''
    },
    regexCheck(postCode) {
      const regex = /^([A-Z]{2})([0-9]{5,})$/gm;
      let m = regex.exec(postCode);
      
      if(m == null || m.length == 0)
        return false
      else
        return true
    },
    regexCheckAras(postCode) {
      const regexAras = /^([0-9]{11,})$/gm;
      let m = regexAras.exec(postCode);
      
      if(m == null || m.length == 0)
        return false
      else
        return true
    },
    arizaUrunCikisiYap() {
      if(this.outgoingPostDate == null || this.outgoingPostDate == undefined || this.outgoingPostDate.length == 0) {
        this.$toasted.error('Ürün çıkış tarihini seçmediniz.', this.toastOptions)
        return
      }

      this.$wait.start('export-loading')

      let assignJson = {}
      assignJson.SessionId = this.getSessionId
      assignJson.ArizaId = parseInt(this.selectedArizaId)
      assignJson.PostDate = this.outgoingPostDate
      assignJson.OutGoingNote = this.outgoingNote
      assignJson.OutGoingDeviceId = this.outGoingDeviceId
      assignJson.PostWaybillCode = this.postWaybillCode
      assignJson.HandDelivery = this.handDelivery

      axios.post('/api/arizakayit/urun-cikisi-yap', assignJson)
      .then(response => {
        if(response.data.HasError == true)
          this.$toasted.error('Ürün çıkışı yapılamadı. Durum mesajı : ' + response.data.ErrorMessage, this.toastOptions)
        else {
          this.arizalar[this.selectedArizaIndex].STATUS = this.handDelivery ? 5 : 3
          this.$toasted.success('Ürün çıkışı yapıldı', this.toastOptions)
          this.getArizaKayitlari()

          $('#exportDeviceModal').modal('hide')
          this.$wait.end('export-loading')
        }
      })
      .catch(error => { console.log(error) 
        this.$wait.end('export-loading')
      })

      this.outGoingDeviceId = null
    },
    selectAriza(arizaId, arizaIndex) {
      this.selectedAriza = this.arizalar[arizaIndex]
      this.outGoingDeviceId = this.selectedAriza.DEVICE_ID

      this.selectedArizaId = arizaId
      this.selectedArizaIndex = arizaIndex

      this.moveDeviceModel.ArizaId = arizaId
      this.moveDeviceModel.DeviceId = this.selectedAriza.DEVICE_ID
    },
    listModeChange() {
      this.page = 0;
      this.getArizaKayitlari()
    },
    cropData(val, len) { 
      if(val == null || val == undefined)
        return null;

      if((val.length + 3) > len) return val.substring(0, len) + '...' 
      else return val
    },
    parseGelenMalzemeler(val) {
      if(val == null) return;
      
      let firstArray = val.split(',');
      let fullValue = [];

      for(var l = 0; l < firstArray.length; l++) {
        let inner = firstArray[l].split('-');
        let one = {};
        one.PieceId = inner[0];
        one.Status = inner[1];
        one.PieceName = this.getPieceNameById(inner[0])

        fullValue.push(one);
      }
      
      return fullValue;
    },
    getPieceNameById(pid) {
      for(var k = 0; k < this.pieces.length; k++) {
        if(this.pieces[k].PieceId == pid)
          return this.pieces[k].PieceName
      }
    },
    dateFormatter(date) {
      return moment(date).format('L')
    },
    parsePostTrackingLink(ptCode, ptComp) {
      if(ptComp == 1)
        return ptCode ? "https://www.araskargo.com.tr/tr/cargo_tracking_detail.aspx?r=3840731query%3d1&querydetail=2&ref_no=&seri_no=&irs_no=&kargo_takip_no="+ ptCode +"&atf_no=&customer_code=&integration_code=" : null
      else
        return ptCode ? "https://service.mngkargo.com.tr/iactive/popup/KargoTakip/link12.asp?k="+ptCode+"&y=2019" : null
    },
    parseLastMessage(lastMsg) {
      if(!lastMsg) return null;
      let mq = lastMsg.split('|');
      return mq;
    },
    isRecordMovable(status, outgoing) {
      if(outgoing != null || (status != 3 && status != 5 && status != 6))
        return true
      else
        return false; 
    },
    selectPostComp(pc) {
      this.postCompany = pc
    }
  },
  mounted() {
    moment.locale('tr')
    this.getArizaKayitlari()
  }
}
</script>

<style scoped>

  div.icon-global {
    position: absolute;
    z-index: 3;
    margin-left: -36px;
    margin-top: 24px;
    width: 30px;
    height: 30px;
    padding: 4px 4px 5px 4px;
    border-radius: 15px;
  }

  div.icon-global.bg-danger {
    margin-top: -6px !important;
  }

  div.icon-global i {
    color: #FFF;
  }

  .margin-negative {
    margin-bottom: -4px !important;
  }

  input.btn-more-radius {
    text-indent: 10px;
  }

  .table-row {
    display: block;
    width: 100%;
  }
  
  table { caption-side: top !important; }
  table, .dropdown-item {
    font-size: .875rem;
  }

  td .btn {
    font-size: 0.875rem;
  }

  td a.btn {
    font-size: .875rem;
  }

  .btn i {
    color: #FFF;
  }

  .btn:hover i {
    color: #FFF !important;
  }

  tr.collapsed-row {
    background: #F0F0F0;
    /*-webkit-box-shadow: inset 0px 5px 30px -15px rgba(102,102,102,1);
    -moz-box-shadow: inset 0px 5px 30px -15px rgba(102,102,102,1);
    box-shadow: inset 0px 5px 30px -15px rgba(102,102,102,1);*/
  }

  span.badge {
    font-size: 100%;
    font-weight: 400;
  }

  .vue-wait-class {
    display: block;
    width: 300px;
    text-align: center;
    margin-top: 30px;
    margin-left: auto;
    margin-right: auto;
  }

  .vue-wait-class img {
    width: 160px;
    height: 160px;
    margin: 10px auto 0 auto;
    clear: both;
  }

  .vue-wait-class p {
    width: 100%;
    text-align: center;
    font-size: 20px;
  }

  .no-padding {
    padding: 0;
    margin: 0;
  }

  .no-padding .row {
    margin: 0;
  }

  .no-padding .row .col-md-12, .no-padding .row .col-md-9, .no-padding .row .col-md-3 {
    margin: 0 !important;
    padding: 0 !important;
  }

  .caption {
    font-size: 15px;
    font-weight: 700;
    color: #e9ecef;
    background-color: #010929;
    vertical-align: center;
    padding: 11px 15px 12px 15px;
  }
  
  .conversation-view {
    display: block;
    position: absolute;
    z-index: 2;
    width: 350px;
    height: 70%;
    left: 3%;
    bottom: 4.5%;
    border: 1px solid #dee2e6;

    -webkit-box-shadow: 0px 10px 30px -4px rgba(200,200,200,1);
    -moz-box-shadow: 0px 10px 30px -4px rgba(200,200,200,1);
    box-shadow: 0px 10px 30px -4px rgba(200,200,200,1); 
  }

  .bubble span {
    display: inline-block;
    min-width: 120px !important;
    width: auto;
    max-width: 70%;
    padding: 6px 20px;
    color: #fff;
    background-color: #007bff;
    border-radius: 30px;
  }

  .bubble small {
    display: block;
    width: 100%;
    margin-left: 8px;
    font-size: 75%;
  }

  .bubble.own span {
    background-color: #e83e8c;
  }

  .bubble.own small {
    margin-right: 8px;
  }

  .modal-body-fixed {
    height: 300px;
    max-height: 300px !important;
    overflow: auto;
  }

  .overflow-y {
    min-height: 100%;
    overflow: auto !important;
  }

  .text-truncated {
    display: block !important;
    overflow: hidden !important;
    text-overflow: ellipsis !important;
    white-space: nowrap !important;
  }

</style>


// WEBPACK FOOTER //
// src/components/CihazlarPage.vue